import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../store';
import {UserSubscription} from "../../../../user/user-subscription";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {
  NotificationDialogComponent
} from "../../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../../../shared/utils/text-utils";
import {Utils} from "../../../../shared/utils/utils";
import {UserService} from "../../../../user/user.service";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-switch-plan-annual',
    templateUrl: './switch-plan-annual.component.html',
    styleUrls: ['./switch-plan-annual.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SwitchPlanAnnualComponent implements OnInit {
  @Input() userSubscription: UserSubscription;
  @Input() annualSubscription: UserSubscription;
  @Input() visitors: string;
  @Input() ssdStorage: string;
  @Input() annualVisitors: string;
  @Input() annualSsdStorage: string;
  @Input() annualPrice: number;
  @Input() monthlyPrice: number;
  @Input() annualPriceForCurrent: number;
  @Input() switchToAnnual: boolean;
  @Output() onClickAction?: EventEmitter<any> = new EventEmitter<any>();
  public loading: boolean;
  public switchLoading: boolean;
  public title: string;
  public desc: string;

  constructor(
    private readonly _activeModal: DbActiveModal,
    private readonly _store: Store<fromStore.DbStoreState>,
    private _userService: UserService,
    private _dialogService: DialogService,
  ) { }

  ngOnInit() {
    this._activeModal.resize(598, 700);
    this._activeModal.whiteCloseBtn(false);
    this.title = 'Switch to 10Web’s best plan with <span class="gradient-color">no additional cost!</span>';
    this.desc = 'Upgrade to our AI Ultimate Annual plan today with our limited time offer,<br/> and get unbeatable benefits for the same price you’re paying now.';
  }

  public confirm(): void {
    this.switchLoading = true;
    this._userService.switchToAnnual()
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          if (this.userSubscription && this.userSubscription.paymentType === 'paypal' && response.data && response.data.result.approval_link) {
            localStorage.setItem('dbFromPeriodCycleChange', '1');
            window.location.replace(response.data.result.approval_link);
          } else {
            this._showCycleChangedSuccess(this.annualPriceForCurrent);
          }
          this._activeModal.close();
        }
      });
  }


  private _showCycleChangedSuccess(annualPrice): void {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: 'Billing cycle changed successfully',
      message: TextUtils.getText('text_switchToAnnualSuccessDesc', {
        date: Utils.formatDate(this.userSubscription.nextBillingDate, 'dd MMM, y'),
        price: annualPrice
      }),
      width: 700,
      buttonText: 'Got It',
      buttonColor: 'black',
      buttonAlign: 'right',
      hasCloseButton: true,
      hasGradientBorder: true,
      textAlign: 'left'
    });
  }

}
